import { BenchmarkTypes } from 'types/Benchmark';

const benchmarks = '/benchmarks';
const benchmarkStaticWeighted = `/benchmarks/${BenchmarkTypes.StaticWeighted}`;
const benchmarkAssetWeighted = `/benchmarks/${BenchmarkTypes.AssetWeighted}`;
const benchmarkCompositeWeighted = `/benchmarks/${BenchmarkTypes.CompositeWeighted}`;
const pullForward = `/benchmarks/${BenchmarkTypes.PullForward}`;
const benchmarkAbsoluteReturn = `/benchmarks/${BenchmarkTypes.AbsoluteReturn}`;
const benchmarkCompositeReturn = `/benchmarks/${BenchmarkTypes.CompositeReturn}`;
const manageJobs = `/jobs`;
const noAccess = `/403`;

export const paths = {
  benchmarks,
  benchmarkStaticWeighted,
  benchmarkAssetWeighted,
  benchmarkCompositeWeighted,
  pullForward,
  benchmarkAbsoluteReturn,
  benchmarkCompositeReturn,
  manageJobs,
  noAccess,
};

export const routes = {
  getBenchmarksRoute: () => paths.benchmarks,
  getBenchmarksStaticWeightedRoute: () => paths.benchmarkStaticWeighted,
  getBenchmarkAssetWeightedRoute: () => paths.benchmarkAssetWeighted,
  getBenchmarkCompositeWeightedRoute: () => paths.benchmarkCompositeWeighted,
  getBenchmarkAbsoluteReturnRoute: () => paths.benchmarkAbsoluteReturn,
  getBenchmarkCompositeReturnRoute: () => paths.benchmarkCompositeReturn,
  getBenchmarkDetails: (type: string, id: string) =>
    `${paths.benchmarks}/${type}/${id}`,
  getBenchmark: (type: string | number) => `${paths.benchmarks}/${type}`,
  getDownloadDiagnostics: (id: string, dataEnvironment?: number) =>
    `/${dataEnvironment}/job_histories/${id}/audit_files`,
};
